<template>
  <div>
    <v-card
      tile
      outlined
    >
      <v-container>
        <v-form
          ref="form"
          v-model="formValid"
          @submit.prevent="onSubmit($event)"
        >
          <v-card-text>
            <v-row>
              <v-col cols="4">
                <v-select
                  :items="localizaciones"
                  label="Localización*"
                  v-model="grupo.localizacion"
                  item-text="nombre"
                  item-value="nombre"
                  :no-data-text="selectNoDataText"
                  return-object
                  @change="cargarIdiomasYAulas"
                  :rules="localizacionRules"
                />
              </v-col>

              <v-col cols="4">
                <v-select
                  :items="idiomas"
                  label="Idioma*"
                  v-model="grupo.idioma"
                  item-text="nombre"
                  item-value="nombre"
                  :no-data-text="selectNoDataText"
                  return-object
                  @change="cargarNiveles"
                  :disabled="!grupo.localizacion"
                  :rules="idiomaRules"
                />
              </v-col>

              <v-col cols="4">
                <v-select
                  :items="niveles"
                  label="Nivel*"
                  v-model="grupo.nivel"
                  item-text="descripcion"
                  item-value="description"
                  :no-data-text="selectNoDataText"
                  return-object
                  :disabled="!grupo.idioma"
                  :rules="nivelRules"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="4">
                <v-select
                  :items="dias"
                  label="Días*"
                  v-model="grupo.dia"
                  item-text="descripcion"
                  item-value="description"
                  :no-data-text="selectNoDataText"
                  return-object
                  :rules="diaRules"
                />
              </v-col>

              <v-col cols="4">
                <v-select
                  :items="horarios"
                  label="Horario*"
                  v-model="grupo.horario"
                  item-text="descripcion"
                  item-value="description"
                  :no-data-text="selectNoDataText"
                  return-object
                  :rules="horarioRules"
                />
              </v-col>

              <v-col cols="4">
                <v-autocomplete
                  :items="aulas"
                  v-model="grupo.aula"
                  label="Aula"
                  :search-input.sync="currentAula"
                  item-text="numero"
                  item-value="numero"
                  hide-no-data
                  allow-overflow
                  :disabled="!grupo.localizacion"
                  return-object
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="2">
                <v-text-field
                  type="number"
                  min="1"
                  v-model="grupo.grupos"
                  label="Grupos"
                  clearable
                />
              </v-col>
            </v-row>

            <small>*Indica campo requerido</small>
          </v-card-text>

          <v-card-actions>
            <v-btn
              type="submit"
              color="primary"
              :loading="loading"
              text
              :disabled="!formValid"
            >
              Guardar
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-container>
    </v-card>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { getAllDias } from '@/api/dias.api'
  import { getAllHorarios } from '@/api/horarios.api'
  import { addGrupo } from '@/api/grupos.api'
  import _ from 'lodash'

  export default {
    name: 'GrupoForm',

    props: {
      localizaciones: {
        required: true,
        type: Array,
      },
    },

    data: () => ({
      formValid: false,
      loading: false,
      grupo: null,
      dias: [],
      horarios: [],
      aulas: [],
      niveles: [],
      idiomas: [],

      // reglas validacion
      localizacionRules: [
        v => !!v || 'Selecciona una opción',
      ],
      idiomaRules: [
        v => !!v || 'Selecciona una opción',
      ],
      nivelRules: [
        v => !!v || 'Selecciona una opción'
      ],
      diaRules: [
        v => !!v || 'Selecciona una opción',
      ],
      horarioRules: [
        v => !!v || 'Selecciona una opción',
      ],

      // textos
      selectNoDataText: 'No hay valores',
    }),

    created() {
      this.initialize()
    },

    computed: {
      ...mapGetters('App', {
        cursoActual: 'GET_CURSO_ACTUAL',
      }),

      currentAula: {
        get: function () {
          return (_.isNil(this.grupo.aula)) ? '' : this.grupo.aula.nombre
        },

        set: function () {
          // hacer algo ...
        },
      },
    },

    methods: {
      async initialize() {
        // nuevo grupo
        this.assignGrupo()

        // dias y horarios
        await getAllDias().then(response => this.dias = response.data)
        await getAllHorarios().then(response => this.horarios = response.data)
      },

      assignGrupo() {
        this.grupo = Object.assign(this.newGrupoInstance());
      },

      newGrupoInstance() {
        return {
          curso: this.cursoActual.id,
          localizacion: null,
          nivel: null,
          dia: null,
          horario: null,
          aula: null,
          grupos: null
        }
      },

      async onSubmit(event) {
        this.loading = true;

        // validacion y emit
        if (this.formValid) {
          await addGrupo(this.grupo).then( response => {
            this.$emit('submitAddGrupo', event, response)
            this.$refs.form.reset()
            this.assignGrupo()
          }).catch( error => {
            this.$emit('submitErrorAddGrupo', event, error)
          })
        }

        this.loading = false;
      },

      cargarIdiomasYAulas() {
        this.cargarAulas()
        this.cargarIdiomas()
      },

      cargarAulas() {
        this.aulas = []
        this.grupo.aula = null

        let localizacionSeleccionada = this.grupo.localizacion
        if (_.isNil(localizacionSeleccionada)) {
          return
        }

        this.aulas = localizacionSeleccionada.aulas.map(aula => aula)
      },

      cargarIdiomas() {
        this.idiomas = []
        this.grupo.idioma = null

        let localizacionSeleccionada = this.grupo.localizacion
        if (_.isNil(localizacionSeleccionada)) {
          return
        }

        this.idiomas = localizacionSeleccionada.idiomas.map(idioma => idioma.idioma)
      },

      cargarNiveles() {
        this.niveles = []
        this.grupo.nivel = null

        let idiomaSeleccionado = this.grupo.idioma
        if (_.isNil(idiomaSeleccionado)) {
          return
        }

        let localizacionSeleccionada = this.grupo.localizacion
        if (_.isNil(localizacionSeleccionada)) {
          return
        }

        this.niveles = localizacionSeleccionada.niveles.filter(nivel => nivel.idioma.id == idiomaSeleccionado.id)
      },
    }
  }
</script>
